
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.listing-order-and-filter').forEach(function (container) {
    // ====== Selectores ======
    const root             = container.closest('section.yarn-search');
    const sectionId        = root?.getAttribute('data-section-id') || 'default';
    const LS_KEY           = 'ys_filters_v2_' + sectionId;

    const fiberChecks      = container.querySelectorAll('.material-filter-checkbox[type="checkbox"]');
    const weightChecks     = container.querySelectorAll('.weight-checkbox[type="checkbox"]');
    const includeBlendsCb  = container.querySelector('#include-blends');              // toggle (ON = permitir blends)
    const searchInput      = container.querySelector('[data-search-input]');
    const items            = container.querySelectorAll('[data-materials][sortable]');
    const sorterSelect     = container.querySelector('#sorter-select');               // <select> unificado
    const listContainer    = container.querySelector('.collection-listing .row');

    // Config de filtros
    const requireFilters = (container.getAttribute('data-require-filters') || 'false') === 'true';

    if (!items.length) return;

    // ====== Helpers ======
    const toCleanArray = (csv) =>
      (csv || '')
        .split(',')
        .map(s => s.trim().toLowerCase())
        .filter(Boolean);

    const uniq = (arr) => Array.from(new Set(arr));

    const setsEqual = (aArr, bArr) => {
      const A = new Set(aArr);
      const B = new Set(bArr);
      if (A.size !== B.size) return false;
      for (const v of A) if (!B.has(v)) return false;
      return true;
    };

    const hasAnyFilter = (fibers, weights, q) =>
      fibers.length > 0 || weights.length > 0 || q.length > 0;

    // ====== Persistencia ======
    function collectState() {
      return {
        fibers:  Array.from(fiberChecks).filter(cb => cb.checked).map(cb => (cb.value || '').toLowerCase().trim()),
        weights: Array.from(weightChecks).filter(cb => cb.checked).map(cb => (cb.value || '').toLowerCase().trim()),
        blends:  !!includeBlendsCb?.checked,
        q:       (searchInput?.value || '').trim(),
        sort:    sorterSelect ? sorterSelect.value : null
      };
    }

    function saveState() {
      try { localStorage.setItem(LS_KEY, JSON.stringify(collectState())); } catch(e) {}
    }

    function loadState() {
      try {
        const raw = localStorage.getItem(LS_KEY);
        return raw ? JSON.parse(raw) : null;
      } catch(e) { return null; }
    }

    function applyState(state) {
      if (!state) return;

      // Fibers
      if (Array.isArray(state.fibers)) {
        fiberChecks.forEach(cb => {
          const v = (cb.value || '').toLowerCase().trim();
          cb.checked = state.fibers.includes(v);
        });
      }

      // Weights
      if (Array.isArray(state.weights)) {
        weightChecks.forEach(cb => {
          const v = (cb.value || '').toLowerCase().trim();
          cb.checked = state.weights.includes(v);
        });
      }

      // Blends
      if (typeof state.blends === 'boolean' && includeBlendsCb) {
        includeBlendsCb.checked = state.blends;
      }

      // Search
      if (typeof state.q === 'string' && searchInput) {
        searchInput.value = state.q;
      }

      // Sort
      if (state.sort && sorterSelect) {
        const found = Array.from(sorterSelect.options).some(o => o.value === state.sort);
        if (found) sorterSelect.value = state.sort;
      }
    }

    // ====== Ordenamiento ======
    function getSortKeyFn(sortby) {
      switch ((sortby || '').toLowerCase()) {
        case 'name':
          return el => (el.getAttribute('data-title') || '').toLowerCase();
        case 'price':
          return el => parseFloat(el.getAttribute('price') || '0') || 0;
        case 'weight':
          return el => parseFloat(el.getAttribute('weight') || '0') || 0;
        case 'popularity':
          return el => parseFloat(el.getAttribute('popularity') || '0') || 0;
        default:
          return el => (el.getAttribute('data-title') || '').toLowerCase();
      }
    }

    function sortCollections(sortby, order) {
      const visibleEls = Array.from(items).filter(el => el.style.display !== 'none');
      if (!visibleEls.length || !listContainer) return;

      const keyFn = getSortKeyFn(sortby);
      const dir   = (order || 'asc').toLowerCase() === 'desc' ? -1 : 1;

      visibleEls.sort((a, b) => {
        const ka = keyFn(a), kb = keyFn(b);
        if (typeof ka === 'number' && typeof kb === 'number') return (ka - kb) * dir;
        return (ka > kb ? 1 : ka < kb ? -1 : 0) * dir;
      });

      // Reinsertar los visibles ordenados
      visibleEls.forEach(el => listContainer.appendChild(el));
    }

    function applySortingToVisible() {
      let sortValue = sorterSelect ? sorterSelect.value : null;

      // fallback a claves legacy si no hay valor en el select
      if (!sortValue) {
        const oldSortby = localStorage.getItem('sortby');
        const oldOrder  = localStorage.getItem('order');
        if (oldSortby && oldOrder) sortValue = `${oldSortby}|${oldOrder}`;
      }

      // default
      if (!sortValue) {
        sortValue = 'weight|desc';
        if (sorterSelect) sorterSelect.value = sortValue;
      }

      // reflejar y aplicar
      if (sorterSelect) {
        const found = Array.from(sorterSelect.options).some(o => o.value === sortValue);
        if (found) sorterSelect.value = sortValue;
        const [sortby, order] = sorterSelect.value.split('|');
        // sync legacy (opcional)
        localStorage.setItem('sortby', sortby);
        localStorage.setItem('order',  order);
        sortCollections(sortby, order);
      }
    }

    // ====== Filtrado ======
    function filterCollections() {
      const selectedFibers = Array.from(fiberChecks)
        .filter(cb => cb.checked)
        .map(cb => cb.value.toLowerCase().trim());

      const selectedWeights = Array.from(weightChecks)
        .filter(cb => cb.checked)
        .map(cb => cb.value.toLowerCase().trim());

      const query       = (searchInput?.value || '').trim().toLowerCase();
      const allowBlends = !!includeBlendsCb?.checked;

      // Blends ON => OR ; Blends OFF => AND + exact match
      const dynamicMode = allowBlends ? 'or' : 'and';

      // Yarn Search: sin filtros/consulta => ocultar todo si requireFilters = true
      if (requireFilters && !hasAnyFilter(selectedFibers, selectedWeights, query)) {
        items.forEach(item => { item.style.display = 'none'; });
        return applySortingToVisible();
      }

      items.forEach(item => {
        const mats   = uniq(toCleanArray(item.getAttribute('data-materials')));
        const parent = (item.getAttribute('data-parent') || '').trim().toLowerCase(); // "weight"
        const title  = (item.getAttribute('data-title')  || '').trim().toLowerCase();

        // 1) Fiber logic
        let fiberOk = true;
        if (selectedFibers.length > 0) {
          if (allowBlends) {
            // OR entre fibras seleccionadas
            if (dynamicMode === 'or') {
              fiberOk = selectedFibers.some(f => mats.includes(f));
            } else {
              fiberOk = selectedFibers.every(f => mats.includes(f));
            }
          } else {
            // Blends OFF: set EXACTO (ni más ni menos) y además debe incluir todas
            fiberOk = setsEqual(mats, uniq(selectedFibers)) && selectedFibers.every(f => mats.includes(f));
          }
        }

        // 2) Weight logic (OR entre seleccionados)
        let weightOk = true;
        if (selectedWeights.length > 0) {
          weightOk = selectedWeights.includes(parent);
        }

        // 3) Text search
        let textOk = true;
        if (query) {
          textOk = title.includes(query);
        }

        item.style.display = (fiberOk && weightOk && textOk) ? '' : 'none';
      });

      applySortingToVisible();
      saveState(); // guarda después de aplicar
    }

    // ====== Listeners ======
    fiberChecks.forEach(cb => cb.addEventListener('change', filterCollections));
    weightChecks.forEach(cb => cb.addEventListener('change', filterCollections));
    includeBlendsCb?.addEventListener('change', filterCollections);

    if (searchInput) {
      // debounce ligero
      let t = null;
      searchInput.addEventListener('input', () => {
        clearTimeout(t);
        t = setTimeout(filterCollections, 180);
      });
    }

    if (sorterSelect) {
      sorterSelect.addEventListener('change', () => {
        const [sortby, order] = sorterSelect.value.split('|');
        // sync legacy + estado
        localStorage.setItem('sortby', sortby);
        localStorage.setItem('order',  order);
        sortCollections(sortby, order);
        saveState();
      });
    }

    // Evitar que el summary de "Include Blends" abra/cierre (toggle inline)
    const includeMixDetails = container.querySelector('.filter-dropdown[data-filter="include-mix"]');
    if (includeMixDetails) {
      const summary = includeMixDetails.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (e) => {
          const isToggle = e.target.closest('.i-toggle');
          if (!isToggle) e.preventDefault(); // bloquea apertura del <details>
        });
      }
    }

    // ====== Estado inicial ======
    function initialState() {
      // 1) Restaurar si hay guardado
      const saved = loadState();
      if (saved) applyState(saved);
      else {
        // 2) Defaults si no hay guardado
        fiberChecks.forEach(cb => cb.checked = false);
        weightChecks.forEach(cb => cb.checked = false);
        if (includeBlendsCb) includeBlendsCb.checked = true; // default ON
        if (searchInput) searchInput.value = '';
        if (sorterSelect && !sorterSelect.value) sorterSelect.value = 'weight|desc';
      }

      // Cierra dropdowns (por si BFCache o HTML los deja abiertos)
      container.querySelectorAll('.filter-dropdown[open]').forEach(d => d.removeAttribute('open'));

      // Aplicar filtrado + sort según el estado actual
      filterCollections();
    }

    initialState();

    // ====== BFCache ======
    window.addEventListener('pageshow', function () {
      initialState();
    });
  });
});
